module.exports = "#top-nav h1.privacy {\n    color: #fff;\n    font-size: 22px;\n    line-height: 48px;\n    margin: 3px;\n}\n.privacypolicy{background: #fff;}\n.privacy-content > h5{\n    padding: 10px 0px;\n    font-size: 16px;\n    color: #3c3c3c;\n    margin: 0px;\n}\n.privacy-content > ol{\n    padding: 10px 0 0 30px;\n    line-height: 22px;\n}\n.privacy-content > ol li{\n    padding: 4px 0px;\n}\n.privacy-content > ol li ul li{\n    padding: 4px 0px;\n    list-style-type: disc;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy/privacy-policy/privacy-policy.component.css
// module id = ./src/app/privacy/privacy-policy/privacy-policy.component.css
// module chunks = main